import { FormControlLabel, Radio, Stack, Typography } from '@mui/material'
import type { FC, SVGProps } from 'react'

const LayoutRadioRow: FC<{
  value: string
  name: string
  description: string[]
  Image: FC<SVGProps<SVGSVGElement> & { title?: string | undefined }>
}> = ({ value, name, description, Image }) => (
  <FormControlLabel
    value={value}
    control={<Radio />}
    label={
      <Stack>
        <Typography sx={{ py: 1 }}>{name}</Typography>
        <Stack direction="row" alignItems="flex-start" spacing={2}>
          <Image style={{ minWidth: 160 }} />
          {description.map(line => (
            <Typography variant="body2" key={line}>
              {line}
            </Typography>
          ))}
        </Stack>
      </Stack>
    }
    sx={{ width: '100%', alignItems: 'flex-start' }}
  />
)

export default LayoutRadioRow
